import React from "react";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import { useParams } from "react-router-dom";
import CheckoutFormPanel from "./CheckoutFormPanel";
import SupportContact from "./SupportContact";
import useOfferConfig from "./hooks/useOfferConfig";
import { useOfferCheckoutStyles } from "./offerCheckout.styles";
import AiSensyLogo from "../../static/AiSensyLogo.svg";

/**
 * Route entry for /offer/:offerSlug.
 * Fetches the offer config from agenda-rest-api and renders the panel.
 * Shows a minimal loader while in flight and an error card on failure.
 */
const OfferCheckoutPage = () => {
  const { offerSlug } = useParams();
  const classes = useOfferCheckoutStyles();
  const { offer, loading, error, reload } = useOfferConfig(offerSlug);

  if (loading) {
    return (
      <div className={classes.loadingRoot}>
        <img src={AiSensyLogo} alt="AiSensy" className={classes.loadingLogo} />
        <CircularProgress size={32} style={{ color: "#04cf66" }} />
      </div>
    );
  }

  if (error || !offer) {
    const isNotFound = error && (error.status === 404 || error.status === 400);
    return (
      <div className={classes.errorRoot}>
        <div className={classes.errorCard}>
          <Typography className={classes.errorHeading}>
            {isNotFound ? "Offer not available" : "We couldn't load this offer"}
          </Typography>
          <Typography className={classes.errorMessage}>
            {isNotFound
              ? "This link may have expired or been taken down. Please check with whoever shared it."
              : error?.message ||
                "Something went wrong while loading the page. Please retry."}
          </Typography>
          {!isNotFound && (
            <Button
              variant="contained"
              className={classes.retryButton}
              onClick={reload}
            >
              Retry
            </Button>
          )}
          <SupportContact compact />
        </div>
      </div>
    );
  }

  return <CheckoutFormPanel offer={offer} />;
};

export default OfferCheckoutPage;
